import { Checkbox } from "@/components/ui/checkbox";
import { ComponentProps } from "react";

type CheckFieldProps = ComponentProps<typeof Checkbox> & {
  label?: string;
  error?: string;
};

const CheckboxField = ({ ...props }: CheckFieldProps) => {
  return (
    <div className={`flex flex-col gap-1 ${props.error ? "text-red-500" : ""}`}>
      <div
        className={`flex ${props.disabled ? "cursor-default" : "cursor-pointer"} min-w-0 items-center gap-2`}
      >
        <Checkbox
          id={props.name}
          defaultChecked={props.defaultChecked}
          name={props.name}
          checked={props.checked}
          onChange={props.onChange}
          disabled={props.disabled}
          onCheckedChange={props.onCheckedChange} // Use onCheckedChange for Radix UI Checkbox
        />
        <label
          className={`${props.disabled ? "cursor-default" : "cursor-pointer"} min-w-0 text-sm break-words`}
          htmlFor={props.name}
        >
          {props.label}
        </label>
      </div>
      {props.error && (
        <span className="pt-1 pl-1 text-xs text-red-500">{props.error}</span>
      )}
    </div>
  );
};

export default CheckboxField;
